import { forwardRef } from "react";
import type { ForwardedRef } from "react";
import { cx } from "../../../utils/classnames";
import type { InputSize } from "./utils";
import { inputSize } from "./utils";

const translatedPlaceholder = (locale: string) => {
  switch (locale) {
    case "es":
      return "Año";
    case "en":
    default:
      return "Year";
  }
};

const YearInputComponent = (
  props: {
    error?: boolean;
    size: InputSize;
    borderLess?: boolean;
    className?: string;
    readOnly?: boolean;
    value: string;
    onChange: (v: string) => void;
    locale: string;
  },
  ref?: ForwardedRef<HTMLInputElement>
) => {
  const {
    error,
    size,
    borderLess,
    className,
    readOnly,
    value,
    onChange,
    locale
  } = props;
  return (
    <input
      className={cx(
        "border-alpha-100 focus:border-primary-100 shadow-xs focus:shadow-focus-ring placeholder:text-content-100 border-alpha-100 mb-2 w-full rounded-md border border text-base font-medium placeholder:text-base placeholder:font-normal focus:outline-0 focus:ring-0",
        error ? "text-danger-700 border-danger-300" : "",
        readOnly ? "bg-alpha-40 text-content-100" : "",
        inputSize[size],
        borderLess
          ? "placeholder:text-content-100 border-0 border-transparent p-0 text-2xl text-gray-600 shadow-none placeholder:text-2xl placeholder:font-semibold placeholder:italic"
          : "p-2 px-3",
        className
      )}
      disabled={readOnly}
      inputMode="numeric"
      max={9999}
      maxLength={4}
      min={1}
      onChange={(e) => {
        let unformattedV: string[] | string = Array.from(
          (e.target.value || "").replace(/\D/g, "")
        );

        if (unformattedV.length > 4) {
          unformattedV = unformattedV.slice(0, 4);
        }

        unformattedV = unformattedV.join("");

        const v = Number(unformattedV);

        if (!e.target.value) {
          onChange("");
        }

        if (isNaN(v)) {
          onChange("");
        } else if (v > 9999) {
          onChange("9999");
        } else if (v < 1) {
          if (!v) {
            onChange("");
          } else {
            onChange("1");
          }
        } else {
          onChange(String(v));
        }
      }}
      onFocus={(e) => {
        e.currentTarget.scrollIntoView({ behavior: "smooth", block: "center" });
      }}
      onWheel={(e) => {
        (e as unknown as { target: { blur: () => void } }).target.blur();
      }}
      placeholder={translatedPlaceholder(locale)}
      ref={ref}
      type="text"
      value={value}
    />
  );
};
const YearInput = forwardRef(YearInputComponent);
YearInput.displayName = "Date-YearInput";

export { YearInput };
